module.exports = __webpack_public_path__ + "files/3a50376ffb4bccdaede9e0ce398de9dd.svg";